import { BidsService } from '@/core/services/bids.service'
import { BidsI } from '../interfaces/bids.interface'
import {
    BidsGetBidsParamsT,
    BidsGetBidsResponseT,
    BidsGetBidsOnSignParamsT,
    BidsGetBidsOnSignResponseT,
    BidsGetBidResponseT,
    BidsGetBidStatusesResponse,
    BidsGetFtlExcelParams,
    BidsEditSignersPayload,
    GetBidByIdDovogor24Response,
} from '../types/bids.types'

const bidsService = new BidsService()

class BidsRealisation implements BidsI {
    resendToContract(id: number): Promise<void> {
        return bidsService.resendToContract(id)
    }

    resendToContractFtl(id: number): Promise<void> {
        return bidsService.resendToContractFtl(id)
    }

    getBid(id: number): Promise<BidsGetBidResponseT> {
        return bidsService.getBid(id)
    }

    getBidNew(id: number): Promise<BidsGetBidResponseT> {
        return bidsService.getBidNew(id)
    }

    getBids(params: BidsGetBidsParamsT): Promise<BidsGetBidsResponseT> {
        return bidsService.getBids(params)
    }

    getLogistBidStatuses(): Promise<BidsGetBidStatusesResponse> {
        return bidsService.getLogistBidStatuses()
    }

    getTmsBids(params: BidsGetBidsParamsT): Promise<BidsGetBidsResponseT> {
        return bidsService.getTmsBids(params)
    }

    getDogovor24ById(bidId: number): Promise<GetBidByIdDovogor24Response> {
        return bidsService.getDogovor24ById(bidId)
    }

    getBidsOnSign(params: BidsGetBidsOnSignParamsT): Promise<BidsGetBidsOnSignResponseT> {
        return bidsService.getBidsOnSign(params)
    }

    createBidFtl(id: number, payload: FormData): Promise<void> {
        return bidsService.createBidFtl(id, payload)
    }

    createBid(payload: FormData): Promise<void> {
        return bidsService.createBid(payload)
    }

    deleteBid(id: number): Promise<void> {
        return bidsService.deleteBid(id)
    }

    deleteTmsBid(id: number): Promise<void> {
        return bidsService.deleteTmsBid(id)
    }

    downloadContract(bid_id: number): Promise<any> {
        return bidsService.downloadContract(bid_id)
    }

    editSigners(id: number, payload: BidsEditSignersPayload): Promise<any> {
        return bidsService.editSigners(id, payload)
    }

    downloadFtlBidsExcel(params: BidsGetFtlExcelParams): Promise<any> {
        return bidsService.downloadFtlBidsExcel(params)
    }
}

export const bids = new BidsRealisation()
